import React from "react";
import { motion } from "framer-motion";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-36 bg-white border-y border-slate-200">
      <div className="mx-auto max-w-7xl section-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-3">
          <p className="label-caps text-berry">About</p>
        </div>
        <div className="lg:col-span-9">
          <motion.blockquote
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight text-navy"
          >
            "Numbers only matter when they change a decision. My work sits at the
            intersection of <span className="italic text-berry">rigorous accounting</span> and{" "}
            <span className="italic text-berry">strategic clarity</span> — so leaders can act
            with confidence."
          </motion.blockquote>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-12 grid md:grid-cols-2 gap-8 text-slate-600 leading-relaxed text-base"
          >
            <p>
              I'm a finance and accounting professional specializing in financial
              reporting, cash-flow management, budgeting, forecasting, and business
              performance analysis. Over the years I've closed the books, built the
              models, and — more importantly — translated all of it into stories
              executives can act on.
            </p>
            <p>
              Whether it's a rolling 13-week cash-flow forecast, a variance analysis
              that explains what really happened, or an AI-powered workflow that saves
              a finance team hours each week, my goal is the same: transform financial
              data into clear insights that support better strategic decisions.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
